import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';
import { SealNavigationItem } from '@shipsfocus/seal';
import { ServiceEnum } from 'app/core/constants';
import { environment } from 'environments/environment';

export const defaultNavigation: SealNavigationItem[] = [
  {
    id: 'analytics.analytics',
    title: 'Analytics',
    type: 'group',
    children: [
      {
        id: 'analytics.live_vessel',
        title: 'Live - Vessel',
        type: 'basic',
        link: `/${ROUTE_NAMES.ANALYTICS}/${ROUTE_NAMES.LIVE_VESSEL}`
      },
      {
        id: 'analytics.live_terminal',
        title: 'Live - Terminal',
        type: 'basic',
        link: `/${ROUTE_NAMES.ANALYTICS}/${ROUTE_NAMES.LIVE_TERMINAL}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC
      },
      {
        id: 'analytics.bunker_analysis_group',
        title: 'Bunker Analysis',
        type: 'basic',
        link: `/${ROUTE_NAMES.ANALYTICS}/${ROUTE_NAMES.BUNKER_ANALYSIS}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.exchange_rate',
        title: 'Exchange Rate',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.EXCHANGE_RATE}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'port-expense.agent_soa',
        title: 'Port Expense Analysis',
        type: 'basic',
        link: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.SOA}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  },
  {
    id: 'database.database',
    title: 'Database',
    subtitle: 'elxa Basic Data Management',
    type: 'group',
    children: [
      {
        id: 'database.company',
        title: 'Company',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.COMPANY}`
      },
      {
        id: 'database.department',
        title: 'Department',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.DEPARTMENT}`
      },
      {
        id: 'database.bank',
        title: 'Bank',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.BANK}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'database.user',
        title: 'User',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.USER}`
      },
      {
        id: 'database.vessel_group',
        title: 'Vessel',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.VESSEL}`
      },
      {
        id: 'database.cargo',
        title: 'Cargo',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.CARGO}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC
      },
      {
        id: 'database.port',
        title: 'Port',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.PORT}`
      },
      {
        id: 'database.location',
        title: 'Location',
        type: 'basic',
        link: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.LOCATION}`
      }
    ]
  },
  {
    id: 'port-expense.port-expense',
    title: 'Port Expense',
    type: 'group',
    children: [
      {
        id: 'port-expense.da_management_group',
        title: 'DA | Management',
        type: 'basic',
        link: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.DA_MANAGEMENT}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'port-expense.owners_account_group',
        title: "Owner's Account",
        type: 'basic',
        link: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.OWNERS_ACCOUNT}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  },
  {
    id: 'port-operation.port-operation',
    title: 'Port Operations',
    type: 'group',
    children: [
      {
        id: 'port-operation.ctm_group',
        title: 'Cash to Master',
        type: 'basic',
        link: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.CTM}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC
      },
      {
        id: 'port-operation.port_call_group',
        title: 'Portcall',
        type: 'basic',
        link: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.PORTCALL}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC
      },
      {
        id: 'port-operation.terminal_demurrage',
        title: 'Demurrage',
        type: 'basic',
        link: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.TERMINAL_DEMURRAGE}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC
      }
    ]
  },
  {
    id: 'chartering-and-ops.chartering-and-ops',
    title: 'Chartering & Operations',
    type: 'group',
    children: [
      {
        id: 'chartering-and-ops.vessel_schedule',
        title: 'Vessel Schedule',
        type: 'basic',
        link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_SCHEDULE}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'chartering-and-ops.voyage_charter_group',
        title: 'Voyage Charter',
        type: 'basic',
        link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VOYAGE_CHARTER}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      // {
      //   id: 'chartering-and-ops.vc_invoice_group',
      //   title: 'VC Invoices',
      //   type: 'basic',
      //   link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VC_INVOICES}`,
      //   hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      // },
      {
        id: 'chartering-and-ops.time_charter_group',
        title: 'Time Charter',
        type: 'basic',
        link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.TIME_CHARTER}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'chartering-and-ops.vessel_report_chartering_group',
        title: 'Vessel Reports',
        type: 'basic',
        link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_REPORT_CHARTERING}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      // {
      //   id: 'chartering-and-ops.inventory_supply',
      //   title: 'Inventory Supply',
      //   type: 'basic',
      //   link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.INVENTORY_SUPPLY}`,
      //   hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      // },
      {
        id: 'chartering-and-ops.bunker_supply_group',
        title: 'Bunker Supply',
        type: 'basic',
        link: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.BUNKER_SUPPLY}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  },
  {
    id: 'ship-shore-operation.ship-shore-operation',
    title: 'Ship Shore Operation',
    subtitle: '',
    type: 'group',
    children: [
      {
        id: 'ship-shore-operation.vessel_call_group',
        title: 'Vessel Call',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.VESSEL_CALL}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'ship-shore-operation.pre_arrival_notice',
        title: 'Pre Arrival Notice',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.PRE_ARRIVAL_NOTICE}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'ship-shore-operation.pre_berth_questionnaire',
        title: 'Pre-Berth Questionnaire',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.PRE_BERTH_QUESTIONNAIRE}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  },
  {
    id: 'ship-interface.ship-interface',
    title: 'Ship Interface',
    type: 'group',
    children: [
      {
        id: 'ship-interface.itinerary',
        title: 'Itinerary',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.ITINERARY}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'ship-interface.vessel_report_ship_interface_group',
        title: 'Vessel Report',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'ship-interface.time_sheet_sof',
        title: 'Timesheet',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.TIMESHEET}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'ship-interface.requisitions_group',
        title: 'Requisitions',
        type: 'basic',
        link: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.REQUISITIONS}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  },
  // {
  //   id      : 'requisitions.requisitions',
  //   title   : 'Requisitions',
  //   type    : 'group',
  //   children: [
  //     {
  //       id    : 'requisitions.cash_to_master',
  //       title : 'Cash to Master',
  //       type  : 'basic',
  //       link  : '/requisitions/cash-to-master',
  //       hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
  //     },
  //     {
  //       id    : 'requisitions.request',
  //       title : 'Bunker Request',
  //       type  : 'basic',
  //       link  : '/requisitions/bunker-request',
  //       hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
  //     },
  //   ]
  // },
  {
    id: 'billing.billing',
    title: 'Billing',
    subtitle: '',
    type: 'group',
    children: [
      {
        id: 'billing.approval_board_owner',
        title: 'Approval Board',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.APPROVAL_BOARD_OWNER}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.approval_board_elxa',
        title: 'ELXA Approval',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.APPROVAL_BOARD_ELXA}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.elxa_invoices_group',
        title: 'Elxa Invoices',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.ELXA_INVOICES}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.invoice_management_group',
        title: 'Invoice Management',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.payments_group',
        title: 'Payment Management',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.PROCESSED_PAYMENTS}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.credit_balance',
        title: 'Credit Balance',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.CREDIT_BALANCE}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'billing.floating_account',
        title: 'Floating Account',
        type: 'basic',
        link: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.FLOATING_ACCOUNT}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  },
  {
    id: 'elxa-controls.elxa-controls',
    title: 'ELXA Controls',
    subtitle: '',
    type: 'group',
    children: [
      {
        id: 'elxa-controls.ctm_controls_group',
        title: 'CTM Controls',
        type: 'basic',
        link: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.CTM_CONTROLS}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'elxa-controls.port_expense_controls_group',
        title: 'Port Expense Controls',
        type: 'basic',
        link: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.PORT_EXPENSE_CONTROLS}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'elxa-controls.pre_berth_questionnaire_form',
        title: 'PBQ Form',
        type: 'basic',
        link: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.PRE_BERTH_QUESTIONNAIRE_FORM}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'elxa-controls.xero_controls_group',
        title: 'Xero Controls',
        type: 'basic',
        link: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.XERO_CONTROLS}`,
        hidden: () => environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      },
      {
        id: 'elxa-controls.subscriptions',
        title: 'Subscriptions',
        type: 'basic',
        link: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.SUBSCRIPTIONS}`,
        hidden: () => environment.production || environment.SERVICE_ID === ServiceEnum.GDSC || environment.SERVICE_ID === ServiceEnum.CHEVRON
      }
    ]
  }
];

export const horizontalNavigation: SealNavigationItem[] = [
  {
    id: 'analytics.analytics',
    title: 'Analytics',
    type: 'group',
    children: []
  },
  {
    id: 'database.database',
    title: 'Database',
    type: 'group',
    children: []
  },
  {
    id: 'port-expense.port-expense',
    title: 'Port Expense',
    type: 'group',
    children: []
  },
  {
    id: 'port-operation.port-operation',
    title: 'Port Operations',
    type: 'group',
    children: []
  },
  {
    id: 'chartering-and-ops.chartering-and-ops',
    title: 'Chartering & Operations',
    type: 'group',
    children: []
  },
  {
    id: 'ship-shore-operation.ship-shore-operation',
    title: 'Ship Shore Operation',
    type: 'group',
    children: []
  },
  {
    id: 'ship-interface.ship-interface',
    title: 'Ship Interface',
    type: 'group',
    children: []
  },
  {
    id: 'billing.billing',
    title: 'Billing',
    type: 'group',
    children: []
  },
  {
    id: 'elxa-controls.elxa-controls',
    title: 'ELXA Controls',
    type: 'group',
    children: []
  }
];
